// extracted by mini-css-extract-plugin
export default {"table_generated_container":"table-generated_table_generated_container__0zS2J"};